module.exports = __webpack_public_path__ + "static/media/raduno1975.b71225bb.jpg";